module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-ms.d7050f68.mp4";